<template>
  <div class="container">
    <HeaderLayout :title="`${this.$store.getters.userInfo.tenant.shortName}区域停水全览图`" workTitle="工作台"
      workUrl="/water-pipe-network" />
    <div class="main">
      <big-map ref="bigmap" code="area_water_control_legend" />
    </div>
  </div>
</template>
<script>
import HeaderLayout from '@/layouts/HeaderLayout.vue'
// import BigMap from './components/Water-outage-control-map.vue'
import BigMap from './components/WaterOutageControlMap.vue'
export default {
  components: {
    [BigMap.name]: BigMap,
    HeaderLayout
  },
  data () {
    return {
      map: null,
      openyxcxTable: false,
      openQueryTable: false,
      opensscxTable: false,
      opendlcsTable: false,
      diameter: '',
      material: '',
      sscxInputData: null,
      radioGroupValue: 1,
      cqlString: ''
    }
  },
  mounted () { },
  methods: {}

}
</script>
<style lang="less" scoped>
.container {

  display: flex;
  flex-direction: column;
  height: 100%;

  .main {
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
}
</style>
